import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEur = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.66606 15.6167V16.9996H3.74692V15.6167H7.66606ZM4.22441 7.9707V16.9996H2.5625V7.9707H4.22441ZM7.13896 11.679V13.0247H3.74692V11.679H7.13896ZM7.64126 7.9707V9.35977H3.74692V7.9707H7.64126Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9123 7.9707H14.5742V14.2091C14.5742 14.8995 14.446 15.4597 14.1897 15.8896C13.9334 16.3195 13.584 16.6337 13.1417 16.8322C12.6993 17.0265 12.2012 17.1236 11.6472 17.1236C11.0808 17.1236 10.5765 17.0265 10.1341 16.8322C9.69178 16.6337 9.34451 16.3195 9.09233 15.8896C8.84429 15.4597 8.72026 14.8995 8.72026 14.2091V7.9707H10.376V14.2091C10.376 14.6184 10.4256 14.9346 10.5248 15.1579C10.6282 15.3811 10.7729 15.5341 10.9589 15.6167C11.1449 15.6994 11.3744 15.7408 11.6472 15.7408C11.9201 15.7408 12.1495 15.6994 12.3355 15.6167C12.5216 15.5341 12.6642 15.3811 12.7634 15.1579C12.8626 14.9346 12.9123 14.6184 12.9123 14.2091V7.9707Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.05 7.9707H18.8592C19.4586 7.9707 19.9692 8.07406 20.3909 8.28076C20.8125 8.48747 21.1329 8.79339 21.3521 9.19854C21.5753 9.60368 21.6869 10.1018 21.6869 10.693C21.6869 11.1643 21.6187 11.5736 21.4823 11.9208C21.35 12.264 21.1598 12.5513 20.9118 12.7828C20.6679 13.0143 20.3723 13.1942 20.025 13.3223L19.5227 13.6076H17.1973L17.1911 12.2247H18.822C19.0907 12.2247 19.3139 12.1648 19.4917 12.0449C19.6736 11.925 19.808 11.7596 19.8948 11.5488C19.9857 11.3338 20.0312 11.0878 20.0312 10.8108C20.0312 10.509 19.9899 10.2507 19.9072 10.0357C19.8286 9.81659 19.7025 9.64915 19.5289 9.5334C19.3594 9.41764 19.1362 9.35977 18.8592 9.35977H17.712V16.9996H16.05V7.9707ZM20.2048 16.9996L18.5119 12.9564H20.2544L21.9784 16.9128V16.9996H20.2048Z",
			fill: "black"
		})
	]
});
export default SvgEur;
